import { hasPermissions } from '@/helpers/hasPermissions';

function canAccessTheRoute(permission) {
  return hasPermissions(permission);
}

const MiddlewareService = {
  init(router) {
    router.beforeEach(async (to, from, next) => {
      if (to.matched.some((record) => record.meta.authRequired)) {
        if (!localStorage.getItem('access_token')) {
          next('/');
        } else {
          // Check if the user has the required permission
          const requiredPermission = to.meta.requiresPermission;

          if (requiredPermission && !canAccessTheRoute(requiredPermission)) {
            next('/404');
          } else {
            next();
          }
        }
      } else {
        next();
      }

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    });
  }
};

export default MiddlewareService;
